import React from "react";
import "./styles.scss";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { withStyles } from "@mui/styles";
import { connect } from "react-redux";
import {
  clearDockFault,
  getDocks,
  unlockDock,
  updateDock,
} from "../../../actions/docks";
import { isErrorClearable } from "../../../constants/errorCodeConfig";
import {
  DOCK_CITY,
  DOCK_CODE,
  DOCK_STATUS,
  DOCK_TYPE,
  MALFUNCTION_STATUS,
  ONLINE_STATUS,
} from "../../../constants/orderConst";
import { strings } from "../../../I18n";
import { useStyles } from "../../../utils/styles";
import { sortedItem, stringFromValue } from "../../../utils/utils";
import DropDownMenu from "../../menu";
import TableHeaderRow from "../../table/tableHeaderRow";
import TableItemRow from "../../table/tableItemRow";
import TabletPaginator from "../../table/tabletPaginator";

function DockItem(props) {
  const {
    docks,
    docksResult,
    handleChangePage,
    unlockDockSuccess,
    clearDockFaultSuccess,
    getDocks,
    orderProps,
    pageSize,
    dockStatuses,
    updateDock,
    savedCity,
  } = props;
  const [pressUnlock, setPressUnlock] = React.useState(false);
  const [pressClearFault, setPressClearFault] = React.useState(false);
  const classes = useStyles();

  React.useEffect(() => {
    if (pressUnlock && unlockDockSuccess) {
      getDocks(0, "", "", savedCity || "", pageSize);
      setPressUnlock(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unlockDockSuccess, pressUnlock, getDocks]);

  React.useEffect(() => {
    if (pressClearFault && clearDockFaultSuccess) {
      getDocks(0, "", "", savedCity || "", pageSize);
      setPressClearFault(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearDockFaultSuccess, pressClearFault, getDocks]);

  const unlock = (dock) => {
    setPressUnlock(true);
    props.unlockDock(dock.id);
  };

  const clearFault = (dock) => {
    setPressClearFault(true);
    props.clearDockFault(dock.id);
  };

  const UnlockButton = withStyles({
    root: {
      fontSize: 14,
      textTransform: "none",
    },
  })(Button);

  const ClearFaultButton = withStyles({
    root: {
      fontSize: 14,
      textTransform: "none",
      backgroundColor: "#f44336",
      "&:hover": {
        backgroundColor: "#d32f2f",
      },
    },
  })(Button);

  const menuItems = (dock) =>
    dockStatuses.map((status) => ({
      action: () => updateDock(dock.id, { status: status }),
      title: status,
    }));

  const dropDown = (dock) => (
    <DropDownMenu menuItems={menuItems(dock)} current={dock?.status} />
  );

  const titles = [
    strings("descriptions.code"),
    strings("descriptions.stationName"),
    strings("descriptions.stationCode"),
    strings("descriptions.bikeName"),
    strings("descriptions.bikeCode"),
    strings("descriptions.type"),
    strings("descriptions.status"),
    strings("descriptions.cityProject"),
    "",
    "",
  ];

  const unlockAction = (dock) =>
    dock?.status === ONLINE_STATUS ? (
      <UnlockButton
        variant="contained"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={() => unlock(dock)}
      >
        {strings("descriptions.unlock")}
      </UnlockButton>
    ) : (
      <div>-</div>
    );

  const clearFaultAction = (dock) => {
    if (dock?.status === MALFUNCTION_STATUS && dock?.lastErrorCode) {
      const canClear = isErrorClearable(dock.lastErrorCode);
      return (
        <ClearFaultButton
          variant="contained"
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={() => clearFault(dock)}
          disabled={!canClear}
        >
          {`Clear E${dock.lastErrorCode}`}
        </ClearFaultButton>
      );
    }
    return <div>-</div>;
  };

  const sortedFields = [
    sortedItem(0, DOCK_CODE, orderProps),
    // sortedItem(2, DOCK_VEHICLE_CODE, orderProps),
    sortedItem(5, DOCK_TYPE, orderProps),
    sortedItem(6, DOCK_STATUS, orderProps),
    sortedItem(7, DOCK_CITY, orderProps),
  ];

  const tabletBody = () => (
    <TableBody>
      {docks.map((dock) => (
        <TableItemRow
          key={dock.code}
          id={dock.code}
          items={[
            stringFromValue(dock.code),
            stringFromValue(dock.station?.name),
            stringFromValue(dock.station?.code),
            stringFromValue(dock.vehicle?.name),
            stringFromValue(dock.vehicle?.code),
            dock.type,
            dropDown(dock),
            stringFromValue(dock.station?.city?.name),
            unlockAction(dock),
            clearFaultAction(dock),
          ]}
        />
      ))}
    </TableBody>
  );

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHeaderRow items={titles} sortedIndexes={sortedFields} />
            {tabletBody()}
          </Table>
        </TableContainer>
        <TabletPaginator
          items={docks}
          pageData={docksResult}
          handleChangePage={handleChangePage}
        />
      </Paper>
    </div>
  );
}

const mapStateToProps = ({
  docks: { unlockDockSuccess, dockStatuses, clearDockFaultSuccess },
  screen: { pageSize },
  cities: { savedCity },
}) => ({
  unlockDockSuccess,
  clearDockFaultSuccess,
  pageSize,
  dockStatuses,
  savedCity,
});

const mapDispatchToProps = {
  unlockDock,
  getDocks,
  updateDock,
  clearDockFault,
};

export default connect(mapStateToProps, mapDispatchToProps)(DockItem);
